/**
 * /tenants/$slug/webhooks/$webhookId/edit — route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchWebhook } from "@/features/webhooks/queries";
import { queryKeys } from "@/lib/query-keys";
import { EditWebhookPage } from "@/features/webhooks/pages/edit-webhook-page";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/webhooks/$webhookId/edit",
)({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.webhooks.detail(context.tenant.id, params.webhookId),
      queryFn: () => fetchWebhook(context.tenant.id, params.webhookId),
    }),
  component: EditWebhookPage,
});
